//CART CALLBACKS

// Announcement bar marquee — fill viewport, mirror for seamless loop, constant scroll speed
(function() {
  var MARQUEE_SPEED = 50;
  var RESIZE_THRESHOLD = 16;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getGapPx(element) {
    var gap = parseFloat(window.getComputedStyle(element).gap);
    return isNaN(gap) ? 0 : gap;
  }

  function measureGroupWidth(group) {
    return group.getBoundingClientRect().width;
  }

  function buildMarquee(content) {
    var wrapper = content.closest('.announcement-bar__wrapper');
    if (!wrapper) return false;

    var unitHtml = content.dataset.marqueeUnit;
    if (!unitHtml) return false;

    content.innerHTML = unitHtml;
    content.classList.remove('is-marquee-ready');

    var gap = getGapPx(content);
    var viewportWidth = wrapper.offsetWidth;
    var firstHalfWidth = measureGroupWidth(content.firstElementChild);

    while (firstHalfWidth + gap < viewportWidth) {
      content.insertAdjacentHTML('beforeend', unitHtml);
      firstHalfWidth += gap + measureGroupWidth(content.lastElementChild);
    }

    var firstHalfCount = content.children.length;
    for (var i = 0; i < firstHalfCount; i++) {
      var mirror = content.children[i].cloneNode(true);
      mirror.setAttribute('aria-hidden', 'true');
      content.appendChild(mirror);
    }

    var halfWidth = content.scrollWidth / 2;
    content.style.setProperty('--marquee-scroll-distance', '-' + halfWidth + 'px');
    content.style.setProperty('--marquee-duration', (halfWidth / MARQUEE_SPEED) + 's');
    content.classList.add('is-marquee-ready');
    return true;
  }

  function initAnnouncementMarquee(content) {
    if (!content || prefersReducedMotion()) return;

    var wrapper = content.closest('.announcement-bar__wrapper');
    var unit = content.querySelector('.announcement-bar__group');
    if (!wrapper || !unit) return;

    if (!content.dataset.marqueeUnit) {
      content.dataset.marqueeUnit = unit.outerHTML;
    }

    var wrapperWidth = wrapper.offsetWidth;
    var lastWidth = parseInt(content.dataset.marqueeWrapperWidth || '0', 10);
    if (
      content.classList.contains('is-marquee-ready') &&
      Math.abs(wrapperWidth - lastWidth) < RESIZE_THRESHOLD
    ) {
      return;
    }

    content.dataset.marqueeWrapperWidth = String(wrapperWidth);
    buildMarquee(content);
  }

  function setupAnnouncementMarquees() {
    document.querySelectorAll('.announcement-bar__content').forEach(initAnnouncementMarquee);
  }

  function bindAnnouncementMarquees() {
    if (prefersReducedMotion()) return;

    setupAnnouncementMarquees();

    if (typeof ResizeObserver !== 'undefined') {
      var resizeTimer;
      var observer = new ResizeObserver(function(entries) {
        var shouldUpdate = entries.some(function(entry) {
          var content = entry.target.querySelector('.announcement-bar__content');
          if (!content) return false;
          var lastWidth = parseInt(content.dataset.marqueeWrapperWidth || '0', 10);
          return Math.abs(entry.contentRect.width - lastWidth) >= RESIZE_THRESHOLD;
        });
        if (!shouldUpdate) return;

        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(setupAnnouncementMarquees, 200);
      });
      document.querySelectorAll('.announcement-bar__wrapper').forEach(function(wrapper) {
        observer.observe(wrapper);
      });
    }
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(bindAnnouncementMarquees);
  } else {
    document.addEventListener('DOMContentLoaded', bindAnnouncementMarquees);
  }

  document.addEventListener('shopify:section:load', function(event) {
    var content = event.target.querySelector('.announcement-bar__content');
    if (!content) return;
    delete content.dataset.marqueeUnit;
    delete content.dataset.marqueeWrapperWidth;
    content.classList.remove('is-marquee-ready');
    initAnnouncementMarquee(content);
  });
})();

// cart toggle
var cartToggle = document.getElementById('cart-toggle');
var viewCart = document.getElementById('view-cart');

// Cart toggle now handled by cart-drawer component
if (viewCart) {
  viewCart.addEventListener("click", function() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.open) {
      cartDrawer.open();
    }
  });
}

// Shared loading state for primary CTAs (add-to-cart / add-to-bundle style).
// Matches the PDP submit pattern: disable the button (grey via :disabled),
// hide the label, and show a centered #icon-spinner. Restores the original
// markup when cleared.
window.setButtonLoading = function(button, isLoading) {
  if (!button) return;

  if (isLoading) {
    if (button.classList.contains('is-loading')) return;
    button.dataset.loadingOriginalHtml = button.innerHTML;
    button.innerHTML =
      '<span class="button__label">' + button.innerHTML + '</span>' +
      '<span class="button__spinner" aria-hidden="true">' +
        '<svg class="icon icon-spinner" viewBox="0 0 32 32" fill="currentColor" stroke="currentColor" width="24" height="24"><use xlink:href="#icon-spinner" /></svg>' +
      '</span>';
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    return;
  }

  if (!button.classList.contains('is-loading')) return;
  if (button.dataset.loadingOriginalHtml !== undefined) {
    button.innerHTML = button.dataset.loadingOriginalHtml;
    delete button.dataset.loadingOriginalHtml;
  }
  button.classList.remove('is-loading');
  button.removeAttribute('aria-busy');
  button.disabled = false;
};

// Show spinner
window.CART_ADD = function() {
  var addButtonSpinner = document.querySelector('.product-form__spinner > .icon-spinner');
  if(addButtonSpinner) {
    addButtonSpinner.classList.add('loading');
    addButtonSpinner.classList.remove('hidden');
  }
};

document.addEventListener('DOMContentLoaded', function() {
  // Find all add to cart buttons
  var addToCartButtons = document.querySelectorAll('button[name="add"].product-form__submit');
  
  // Add click event listener to each button
  addToCartButtons.forEach(function(button) {
    button.addEventListener('click', function(event) {
      // Only run CART_ADD if button is not disabled
      if (!button.disabled) {
        window.CART_ADD();
      }
    });
  });
});

// Hide spinner
window.addToCartCallBack = function(item, items) {
  var addButtonSpinner = document.querySelector('.product-form__spinner > .icon-spinner');
  if(addButtonSpinner) {
    addButtonSpinner.classList.remove('loading');
    addButtonSpinner.classList.add('hidden');
  }
}

// Cart updated
 document.addEventListener("cart:updated", (event) => {
  // Handle case where detail might not be provided - event.detail can be null/undefined
  try {
    const detail = (event && event.detail) || {};
    // items is not actually used in this function, but we check for it safely
    const items = detail.items || null;
    
    fetch(window.Shopify.routes.root + "?section_id=header")
    .then((response) => response.text())
    .then((responseText) => {
      let html = parseHTML(responseText);
      let destination = document.getElementById('cart-toggle');
      let source = html.getElementById('cart-toggle');
      if (source && destination) destination.innerHTML = source.innerHTML;
    });
  } catch (error) {
    console.warn('Error handling cart:updated event:', error);
  }
});

// Splide - use requestAnimationFrame to batch DOM reads/writes and reduce forced reflows
function initSplideWhenReady() {
  if (window.requestAnimationFrame) {
    requestAnimationFrame(function() {
      loadSplideInstances();
      initHeroSections();
    });
  } else {
    loadSplideInstances();
    initHeroSections();
  }
}
if (window.splideLoaded) {
  initSplideWhenReady();
} else {
  document.addEventListener('splideLoaded', function() {
    initSplideWhenReady();
  });
}

function loadSplideInstances() {
  // hero panels
  var elms = document.querySelectorAll( '.splide.intus-hero' );
  if(elms != null && elms.length > 0) {
    for ( var i = 0; i < elms.length; i++ ) {
      var list = elms[i].querySelector('.splide__list');
      var slideCount = list.children.length;
      var type = (slideCount > 1) ? 'loop' : 'fade';
      var splide = new Splide(elms[i], {
            type: type,
            arrows: false,
            autoplay: slideCount > 1,
            pagination: slideCount > 1,
            lazyLoad:'nearby'
          }).mount();  
    }
    
    // Initialize video handling for carousel components
    initVideoCarousels();
  }
}

/**
 * Load lazy hero videos in a slide (used when slide becomes active)
 */
function loadLazyVideosInSlide(slideEl) {
  if (!slideEl) return;
  var lazyVideos = slideEl.querySelectorAll('.hero__video-lazy[data-src]');
  lazyVideos.forEach(function(video) {
    var src = video.getAttribute('data-src');
    if (src && !video.src) {
      video.src = src;
      video.load();
      if (video.getAttribute('data-autoplay') === 'true') {
        video.play().catch(function() {});
      }
      video.removeAttribute('data-src');
    }
  });
  setupHeroVideoPlayback(slideEl);
}

/**
 * Keep poster above video until playback starts; retry play when data is ready.
 */
function setupHeroVideoPlayback(container) {
  if (!container) return;

  var videos = container.querySelectorAll('.hero__video-container video, .bundle-card__media video');
  if (videos.length === 0) return;

  function markPlaying() {
    container.classList.add('is-video-playing');
  }

  function tryPlay(video) {
    if (!video || !video.paused) return;
    if (!video.currentSrc && !video.src && video.hasAttribute('data-src')) return;
    video.muted = true;
    var playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(function() {});
    }
  }

  videos.forEach(function(video) {
    if (video.dataset.heroVideoInit === 'true') return;
    if (!video.currentSrc && !video.src && video.hasAttribute('data-src')) return;
    video.dataset.heroVideoInit = 'true';

    if (!video.paused && video.currentTime > 0) {
      markPlaying();
      return;
    }

    video.addEventListener('playing', markPlaying, { once: true });
    video.addEventListener('loadeddata', function() { tryPlay(video); }, { once: true });
    video.addEventListener('canplay', function() { tryPlay(video); }, { once: true });
    tryPlay(video);
  });
}

function initHeroVideoPlayback() {
  document.querySelectorAll('.hero__slide, .hero__slide-inner, .hero--centered').forEach(setupHeroVideoPlayback);
  document.querySelectorAll('.bundle-grid .bundle-card').forEach(setupHeroVideoPlayback);
}

/**
 * Initialize all INTUS Hero sections on the page
 * Handles carousel initialization and Klaviyo triggers
 */
function initHeroSections() {
  if (typeof Splide === 'undefined') return;
  
  // Initialize all hero carousels
  var heroCarousels = document.querySelectorAll('[data-hero-carousel]');
  heroCarousels.forEach(function(carousel) {
    if (carousel.classList.contains('is-initialized')) return;
    
    var config = {
      type: carousel.getAttribute('data-transition-type') || 'slide',
      autoplay: carousel.getAttribute('data-autoplay') === 'true',
      interval: parseInt(carousel.getAttribute('data-autoplay-speed')) || 5000,
      pauseOnHover: carousel.getAttribute('data-pause-on-hover') === 'true',
      rewind: carousel.getAttribute('data-loop') === 'true',
      arrows: true,
      pagination: carousel.getAttribute('data-pagination') === 'true',
      speed: 600,
      easing: 'ease'
    };
    
    var splide = new Splide(carousel, config);
    splide.on('moved', function() {
      loadLazyVideosInSlide(splide.slides[splide.index]);
    });
    splide.mount();
    carousel.classList.add('is-initialized');
    setupHeroVideoPlayback(splide.slides[splide.index]);
  });

  initHeroVideoPlayback();

  // Initialize Klaviyo triggers globally (only once)
  if (!window.heroKlaviyoInitialized) {
    initHeroKlaviyoTriggers();
    window.heroKlaviyoInitialized = true;
  }
}

/**
 * Initialize Klaviyo form triggers for all hero sections
 * Only needs to run once per page load
 */
function initHeroKlaviyoTriggers() {
  var triggers = document.querySelectorAll('.klaviyo_form_trigger');
  if (triggers.length === 0) return;
  
  triggers.forEach(function(trigger) {
    // Skip if already has event listener
    if (trigger.dataset.klaviyoListenerAdded) return;
    
    trigger.addEventListener('click', function(event) {
      event.preventDefault();
      var formId = trigger.getAttribute('data-klaviyo-form-id');
      if (window._klOnsite && formId) {
        window._klOnsite.openForm(formId);
      }
    });
    
    trigger.dataset.klaviyoListenerAdded = 'true';
  });
}

// Initialize hero sections on DOM ready (backup for direct load)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initHeroVideoPlayback();
    if (window.splideLoaded) {
      initSplideWhenReady();
    }
  });
} else {
  initHeroVideoPlayback();
  if (window.splideLoaded) {
    initHeroSections();
  }
}

// Handle video carousels
function initVideoCarousels() {
  // Find all carousel sections on the page
  var carouselSections = document.querySelectorAll('.intus-hero-wrapper');
  
  carouselSections.forEach(function(section) {
    // Get section ID from the closest Shopify section container
    var sectionContainer = section.querySelector('.splide').closest('[id^="shopify-section"]');
    if (!sectionContainer) return;
    
    var sectionId = sectionContainer.id.replace('shopify-section-', '');
    handleSectionVideos(sectionId, section);
  });
  
  // Add global resize handler for responsive video display
  if (carouselSections.length > 0 && !window.videoResizeHandlerAdded) {
    window.addEventListener('resize', function() {
      carouselSections.forEach(function(section) {
        if (typeof section.updateVideoDisplay === 'function') {
          section.updateVideoDisplay();
        }
      });
    });
    window.videoResizeHandlerAdded = true;
  }
}

// Handle videos for a specific carousel section
function handleSectionVideos(sectionId, sectionElement) {
  // Find all video placeholders in this section
  var videoPlaceholders = sectionElement.querySelectorAll('[class*="video-placeholder-' + sectionId + '"]');
  
  if (videoPlaceholders.length === 0) {
    console.log('No video placeholders found for section:', sectionId);
    return;
  }
  
  console.log('Found ' + videoPlaceholders.length + ' video placeholders for section:', sectionId);
  
  function createAndInsertVideo(placeholder) {
    // Clear any existing videos first
    var container = placeholder.parentElement;
    var existingVideos = container.querySelectorAll('video');
    
    // Fixed: Make sure we're only removing videos that are actually children of this container
    existingVideos.forEach(function(video) {
      video.pause();
      // Check if this video is a child (or nested child) of the container before removing
      if (container.contains(video) && video.parentNode) {
        // Remove from the actual parent, not necessarily the container
        video.parentNode.removeChild(video);
      }
    });
    
    // An alternative approach: remove all video wrappers instead
    var existingWrappers = container.querySelectorAll('.video-wrapper');
    existingWrappers.forEach(function(wrapper) {
      if (wrapper.parentNode === container) {
        container.removeChild(wrapper);
      }
    });
    
    // Get the data attributes
    var isMobile = window.innerWidth < 1024;
    var videoSrc = isMobile ? placeholder.getAttribute('data-mobile-src') : placeholder.getAttribute('data-desktop-src');
    var posterSrc = isMobile ? placeholder.getAttribute('data-mobile-poster') : placeholder.getAttribute('data-desktop-poster');
    var autoplay = placeholder.getAttribute('data-autoplay') === 'true';
    var loop = placeholder.getAttribute('data-loop') === 'true';
    var muted = placeholder.getAttribute('data-muted') === 'true';
    var slideIndex = placeholder.getAttribute('data-slide-index');
    
    // If there's no video source for current device, don't create video
    if (!videoSrc) {
      console.log('No video source for ' + (isMobile ? 'mobile' : 'desktop') + ' in section ' + sectionId + ', slide ' + slideIndex);
      return;
    }
    
    console.log('Creating video for ' + (isMobile ? 'mobile' : 'desktop') + ' in section ' + sectionId + ', slide ' + slideIndex);
    
    // Create new video element with anti-flicker attributes
    var video = document.createElement('video');
    video.className = isMobile ? 
      'mobile-video mobile-video-' + sectionId + '-' + slideIndex : 
      'desktop-video desktop-video-' + sectionId + '-' + slideIndex;
    
    // Set attributes - force autoplay and muted for immediate playback
    video.setAttribute('autoplay', '');
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('disablePictureInPicture', '');
    video.setAttribute('disableRemotePlayback', '');
    
    if (loop) video.setAttribute('loop', '');
    if (posterSrc) video.setAttribute('poster', posterSrc);
    video.setAttribute('data-slide-index', slideIndex);
    video.setAttribute('data-section-id', sectionId);
    
    // Add preload attribute to start loading immediately
    video.setAttribute('preload', 'auto');
    
    // Anti-flicker attributes
    video.style.transform = 'translateZ(0)';
    video.style.webkitTransform = 'translateZ(0)';
    video.style.backfaceVisibility = 'hidden';
    video.style.webkitBackfaceVisibility = 'hidden';
    
    // Create and add source element
    var source = document.createElement('source');
    source.src = videoSrc;
    source.type = 'video/mp4';
    video.appendChild(source);
    
    // Hide placeholder image if it exists
    var posterImg = placeholder.querySelector('.video-poster');
    if (posterImg) {
      posterImg.style.display = 'none';
    }
    
    // Create a wrapper to contain the video (helps with flicker)
    var videoWrapper = document.createElement('div');
    videoWrapper.className = 'video-wrapper';
    videoWrapper.style.position = 'absolute';
    videoWrapper.style.top = '0';
    videoWrapper.style.left = '0';
    videoWrapper.style.width = '100%';
    videoWrapper.style.height = '100%';
    videoWrapper.style.overflow = 'hidden';
    videoWrapper.style.transform = 'translateZ(0)';
    videoWrapper.style.webkitTransform = 'translateZ(0)';
    
    // Add the video to the wrapper
    videoWrapper.appendChild(video);
    
    // Insert wrapper before the placeholder
    container.insertBefore(videoWrapper, placeholder);
    
    // Reduce scroll event impact
    var scrollTimeout;
    window.addEventListener('scroll', function() {
      if (scrollTimeout) {
        // During scroll, optionally hide video
        video.style.opacity = '0.99'; // Slight opacity change can reduce flicker
        clearTimeout(scrollTimeout);
      }
      
      scrollTimeout = setTimeout(function() {
        // After scroll stops
        video.style.opacity = '1';
      }, 50);
    }, { passive: true });
    
    // Play the video with multiple fallbacks
    setTimeout(function() {
      // Method 1: Standard play()
      var playPromise = video.play();
      
      if (playPromise !== undefined) {
        playPromise.then(function() {
          console.log('Video playback started successfully');
        }).catch(function(error) {
          console.log('Autoplay failed: ' + error);
          
          // If autoplay fails, try again with muted
          video.muted = true;
          video.play().catch(function(e) {
            console.log('Autoplay still failed even with muted: ' + e);
          });
        });
      }
      
      // Method 2: Set current time to force re-evaluation
      video.currentTime = 0.1;
    }, 100);
    
    // Add loadeddata event to try playing again when actually loaded
    video.addEventListener('loadeddata', function() {
      video.play().catch(function(error) {
        console.log('Play on loadeddata failed: ' + error);
      });
    });
    
    video.addEventListener('loadedmetadata', function() {
      // This ensures the video is fully loaded before it can be accessed by trackers
      if (typeof video.seek === 'undefined') {
        // Define a dummy seek method if it doesn't exist
        video.seek = function(time) {
          if (time !== undefined) {
            this.currentTime = time;
          }
          return this.currentTime;
        };
      }
    });
    
    return videoWrapper;
  }

  // Process all placeholders
  videoPlaceholders.forEach(createAndInsertVideo);
  
  // Function to update videos on resize
  function updateVideoDisplay() {
    console.log('Updating video display for section:', sectionId);
    videoPlaceholders.forEach(createAndInsertVideo);
  }
  
  // Initialize for this section
  updateVideoDisplay();
  
  // Store reference to this function with the section element
  sectionElement.updateVideoDisplay = updateVideoDisplay;
}
 
// component: accordion
var accordionToggleArr = document.querySelectorAll('.accordion > .toggle');

Array.from(accordionToggleArr).forEach(function(element) {
  element.addEventListener("click", function() {
    element.parentElement.setAttribute('aria-expanded', element.parentElement.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  });
});

// Cart data with caching (consolidated from cart-drawer.js)
let cartCache = null;
let cartCacheTime = 0;
const CART_CACHE_DURATION = 1000; // 1 second cache

/**
 * Get cart data with optional caching
 * @param {boolean} forceRefresh - Force a fresh fetch, bypassing cache
 * @returns {Promise<Object>} Cart data
 */
function getCart(forceRefresh = false) {
  const now = Date.now();
  
  // Return cached cart if still valid and not forcing refresh
  if (!forceRefresh && cartCache && (now - cartCacheTime) < CART_CACHE_DURATION) {
    return Promise.resolve(cartCache);
  }
  
  return fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`Failed to fetch cart: ${response.status}`);
    }
    return response.json();
  })
  .then(cartData => {
    // Cache the result
    cartCache = cartData;
    cartCacheTime = now;
    return cartData;
  })
  .catch((error) => {
    console.error('Error fetching cart:', error);
    throw error;
  });
}

/**
 * Invalidate cart cache (call after cart updates)
 */
function invalidateCartCache() {
  cartCache = null;
  cartCacheTime = 0;
}

// variant selector
class VariantSelects extends HTMLElement {

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    const variantData = this.getVariantData();
    const variants = variantData.variants || variantData;
    if (variants.length === 0) {
      this.currentVariant = null;
      return;
    }
    
    // After CSV split, Color is removed from options, so fieldsets align with variant.options
    // fieldset[0] = variant.options[0], fieldset[1] = variant.options[1], etc.
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    
    // Match variant by comparing all selected options
    this.currentVariant = variants.find((variant) => {
      if (!variant.options) return false;
      
      // Check each fieldset's selected value against corresponding variant.options position
      return fieldsets.every((fieldset, fieldsetIndex) => {
        const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
        if (!checkedRadio) return false; // No selection means no match
        
        const selectedValue = checkedRadio.value;
        // After Color removal, fieldset index directly maps to variant.options index
        return variant.options[fieldsetIndex] === selectedValue;
      });
    });
  }

  updateMedia() {
    // After color split: images are product-level, not variant-specific
    // Gallery uses product.media directly, so no updates needed on variant change
    // This method is kept for API compatibility but does nothing
    return;
  }

  updateColorValue() {
    if (!this.currentVariant) return;
    const colorValueName = document.getElementById('ColorValue');
    if (!colorValueName) return;
    
    // After CSV split, Color is removed from options, so try to get from variant options first
    // If Color option exists, find it dynamically
    const colorFieldset = Array.from(this.querySelectorAll('fieldset')).find(fieldset => {
      const legend = fieldset.querySelector('legend');
      return legend && (legend.textContent.includes('Color') || legend.textContent.includes('Colour'));
    });
    
    if (colorFieldset) {
      // Color option exists - get selected value
      const checkedColor = colorFieldset.querySelector('input[type="radio"]:checked');
      if (checkedColor) {
        colorValueName.innerHTML = checkedColor.value;
        return;
      }
    }
    
    // Fallback: try to get from variant options (for products that still have Color)
    // Check if variant has option2 and it might be Color
    if (this.currentVariant.option2) {
      colorValueName.innerHTML = this.currentVariant.option2;
    }
  }
  
  updateRadioButton(optionName, optionValue, isAvailable) {
    if (optionName.includes("Size")) {
      let radioButton = document.getElementById(handleize(optionName) + "-" + optionValue);
      if (radioButton) {
        isAvailable ? radioButton.classList.remove("sold-out") : radioButton.classList.add("sold-out");
      }
    }
  }

  updateSizeAvailability() {
    if (!this.currentVariant) return;
    
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const variantData = this.getVariantData();
    const variants = variantData.variants || variantData;
    
    // After CSV split, Color is removed, so all variants share the same "color" (product)
    // Update availability for all options based on current selections
    fieldsets.forEach((fieldset, fieldsetIndex) => {
      const legend = fieldset.querySelector('legend');
      if (!legend) return;
      
      const optionName = legend.textContent.trim();
      
      // Get currently selected values for other options (to filter variants)
      const currentSelections = new Map();
      fieldsets.forEach((otherFieldset, otherIndex) => {
        if (otherIndex !== fieldsetIndex) {
          const checked = otherFieldset.querySelector('input[type="radio"]:checked');
          if (checked) {
            currentSelections.set(otherIndex, checked.value);
          }
        }
      });
      
      // Find variants that match current selections (excluding this option)
      const matchingVariants = variants.filter(variant => {
        if (!variant.options) return false;
        
        // Check if variant matches all current selections
        return Array.from(currentSelections.entries()).every(([optionIndex, selectedValue]) => {
          return variant.options[optionIndex] === selectedValue;
        });
      });
      
      // Update availability for each option value in this fieldset
      const radios = fieldset.querySelectorAll('input[type="radio"]');
      radios.forEach(radio => {
        const optionValue = radio.value;
        const label = radio.closest('label');
        if (!label) return;
        
        // Find if there's a matching variant with this value
        const hasAvailableVariant = matchingVariants.some(variant => {
          return variant.options[fieldsetIndex] === optionValue && variant.available;
        });
        
        // Update label classes
        if (hasAvailableVariant) {
          label.classList.remove('product-variant-picker__option--unavailable');
        } else {
          // Check if variant exists but is unavailable
          const variantExists = matchingVariants.some(variant => {
            return variant.options[fieldsetIndex] === optionValue;
          });
          if (variantExists) {
            label.classList.add('product-variant-picker__option--unavailable');
          }
        }
      });
    });
  }

  updateBadges() {
    const variantData = this.getVariantData();
    const byId = variantData.byId || {};
    const meta = byId[this.currentVariant.id];
    if (!meta) return;
    let preorderButton = document.getElementById("badge-preorder");
    if(preorderButton != null)
    {
      if (meta.preorder == true && meta.qty < 1) {
        preorderButton.classList.remove("hidden");
      } else {
        preorderButton.classList.add("hidden");
      }
    }

    let clearanceButton = document.getElementById("badge-clearance");
    if(clearanceButton != null) {
      if (meta.clearance == true) {
        clearanceButton.classList.remove("hidden");
      } else {
        clearanceButton.classList.add("hidden");
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    
    if (window.location.href.indexOf("bundles") > -1) {
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}#bundles`);
    } else {
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      }
    });
  }

  updateStickySizeSelector() {
    const selector = document.querySelector("#sticky-size-selector");
    if (!selector || !this.currentVariant) return;
    
    // Find the first non-Color option fieldset to determine which variant option to use
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const firstFieldset = fieldsets.find(fieldset => {
      const legend = fieldset.querySelector('legend');
      return legend && !legend.textContent.includes('Color') && !legend.textContent.includes('Colour');
    });
    
    if (!firstFieldset) return;
    
    // Get the fieldset index to map to variant.options
    const fieldsetIndex = fieldsets.indexOf(firstFieldset);
    const currentValue = this.currentVariant.options[fieldsetIndex];
    
    if (currentValue) {
      Array.from(selector.options).forEach((option, i) => {
        if (option.value == currentValue) {
          selector.selectedIndex = i;
        }
      });
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm && typeof productForm.handleErrorMessage === 'function') {
      productForm.handleErrorMessage();
    }

    // Also hide the inline picker-adjacent error so it clears when a size
    // is actually selected (otherwise it stays visible after the user fixes
    // the problem).
    const variantError = section.querySelector('[data-variant-error]');
    if (variantError) variantError.hidden = true;
  }

  renderProductInfo() {
    // Sequence guard: ignore responses from superseded variant changes
    this._renderInfoSeq = (this._renderInfoSeq || 0) + 1;
    const seq = this._renderInfoSeq;

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        if (seq !== this._renderInfoSeq) return;
        const sectionsArr = [`product-name`,`sticky-selector`,`product-badges`, `price-${this.dataset.section}`];
        Array.from(sectionsArr).forEach(id => {
          this.renderSection(responseText, id);
        });

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut, true);
      })
      .catch((e) => console.error('Failed to render product info:', e));

    const lookSection = this.dataset.section.replace('main', 'shop-the-look');
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${lookSection}`)
      .then((response) => response.text())
      .then((responseText) => {
        if (seq !== this._renderInfoSeq) return;
        const id = `looks`;
        this.renderSection(responseText, id);
      })
      .catch((e) => console.error('Failed to render shop-the-look:', e));
  }

  renderSection(responseText, id) {
    let html = parseHTML(responseText);
    let destination = document.getElementById(id);
    let source = html.getElementById(id);
    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] [data-button-text], [name="add"] > span');
    const addSpinner = productForm.querySelector('.product-form__spinner .icon-spinner');

    if (!addButton) return;

    try {
      if (addButtonText) addButtonText.textContent = '';
      addButton.classList.add('loading');
      if (addSpinner) addSpinner.classList.remove('hidden');

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text && addButtonText) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        if (addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
      }

      if (!modifyClass) return;
      if (addSpinner) addSpinner.classList.add('hidden');
      addButton.classList.remove('loading');
    } catch (e) {
      console.log("Add button not found.");
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button?.querySelector('[name="add"]');
    const addButtonText = button?.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton || !addButtonText) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    if (this.variantData) return this.variantData;
    try {
      const script = this.querySelector('[type="application/json"]');
      if (!script) return { variants: [], byId: {} };
      const raw = JSON.parse(script.textContent);
      this.variantData = raw.variants && raw.byId ? raw : { variants: raw, byId: {} };
    } catch (e) {
      console.error('Failed to parse variant data:', e);
      this.variantData = { variants: [], byId: {} };
    }
    return this.variantData;
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.removeErrorMessage();

    // Check if no option is selected (null in options array)
    const hasNoSelection = this.options.some(opt => opt === null);
    
    if (hasNoSelection) {
      // No size selected - show "Add to Cart" but require selection on click
      this.setNoSelectionState();
    } else if (!this.currentVariant) {
      // Invalid combination - show unavailable
      this.toggleAddButton(true, window.variantStrings.unavailable, true);
      this.setUnavailable();
    } else if (!this.currentVariant.available) {
      // Variant exists but sold out - show "Sold Out"
      this.toggleAddButton(true, window.variantStrings.soldOut, true);
      this.updateMedia();
      this.updateColorValue();
      this.updateBadges();
      this.updateSizeAvailability();
      this.updateStickySizeSelector();
      this.updateURL();
      this.updateVariantInput();
    } else {
      // Variant available - show "Add to Cart"
      // CRITICAL: Update variant input FIRST, before any other operations that might trigger events
      try {
        const formSelector = `#product-form-${this.dataset.section}`;
        const forms = document.querySelectorAll(`${formSelector}, #product-form-installment`);
        forms.forEach(form => {
          const input = form.querySelector('input[name="id"]');
          if (input && this.currentVariant) {
            if (input.disabled) input.disabled = false;
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      } catch (error) {
        console.error('Error updating variant input:', error);
      }
      this.toggleAddButton(false, '', true);
      this.updateMedia();
      this.updateColorValue();
      this.updateBadges();
      this.updateSizeAvailability();
      this.updateStickySizeSelector();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }
  
  setNoSelectionState() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] [data-button-text], [name="add"] > span');
    const addSpinner = productForm.querySelector('.product-form__spinner .icon-spinner');

    if (!addButton) return;

    // Enable button with "Add to Cart" text - validation happens on click
    addButton.removeAttribute('disabled');
    addButton.classList.remove('loading');
    if (addSpinner) addSpinner.classList.add('hidden');
    if (addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
  }

  constructor() {
    super();
  }

  executeAfterScriptsLoad = () => {
    this.onVariantChange();
    this.addEventListener('change', this.onVariantChange);
  };
  
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    if (window.splideLoaded) {
      // If scripts are already loaded, execute immediately
      this.executeAfterScriptsLoad();
    } else {
      // Wait for the scriptsLoaded event
      document.addEventListener('splideLoaded', this.executeAfterScriptsLoad);
    }
  }

  disconnectedCallback() {
    document.removeEventListener('splideLoaded', this.executeAfterScriptsLoad);
    this.removeEventListener('change', this.onVariantChange);
    this._initialized = false;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  selectVariantFromUrl() {
    const variantId = new URLSearchParams(window.location.search).get('variant');
    if (!variantId) return;

    const variantData = this.getVariantData();
    const variants = variantData.variants || variantData;
    const variant = variants.find(v => String(v.id) === variantId);
    if (!variant || !variant.options) return;

    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    fieldsets.forEach((fieldset, index) => {
      const targetValue = variant.options[index];
      if (!targetValue) return;
      const radio = Array.from(fieldset.querySelectorAll('input[type="radio"]'))
        .find(r => r.value === targetValue);
      if (radio) radio.checked = true;
    });
  }

  executeAfterScriptsLoad = () => {
    this.selectVariantFromUrl();
    this.onVariantChange();
    this.addEventListener('change', this.onVariantChange);
  };

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      return checkedRadio ? checkedRadio.value : null;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

//sticky size selector
class StickySelector extends HTMLElement {
    constructor() {
      super();
      this.selector = this.querySelector('select');
      if (this.selector) {
        this.selector.addEventListener("change", this.onSelectUpdated.bind(this));
      }
    }

   onSelectUpdated() {
     var root = this.closest('main-product, product-form, [data-product-root], .product');
     var variantRadios = root ? root.querySelector('variant-radios') : null;
     if (!variantRadios) {
       variantRadios = document.querySelector('main-product variant-radios');
     }
     if (!variantRadios) return;
     
     var index = this.selector.selectedIndex;
     var value = this.selector.options[index].getAttribute('value');
     var targetInput = variantRadios.querySelector("input[value='"+value+"']");
     if (targetInput) {
       targetInput.click();
     }
   }
 }

customElements.define('sticky-selector', StickySelector);

//zoom
const zoomBtn = document.getElementsByClassName("slider--zoom")[0];

function zoomIn() {
  document.querySelector('.slider--controls').classList.add("zoomed");
  document.querySelector('.product__selector-container').classList.add("zoomed");
  zoomBtn.removeEventListener('click', zoomIn, false);
  zoomBtn.addEventListener('click', zoomOut, false);
}

function zoomOut() {
  document.querySelector('.slider--controls').classList.remove("zoomed");
  document.querySelector('.product__selector-container').classList.remove("zoomed");
  zoomBtn.removeEventListener('click', zoomOut, false);
  zoomBtn.addEventListener('click', zoomIn, false);
}

if (zoomBtn) {
  zoomBtn.addEventListener('click', zoomIn, false);
}

// Shopify JS
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling?.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  // No focusable elements: nothing to cycle, just focus the target and bail
  if (!first || !last) {
    if (elementToFocus && typeof elementToFocus.focus === 'function') {
      elementToFocus.focus();
    }
    return;
  }

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  // Attach keydown immediately so Tab cycles first<->last even before focusin fires
  document.addEventListener('keydown', trapFocusHandlers.keydown);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', {
      bubbles: true
    });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': `application/${type}`
    }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

function handleize(text) {
  return text.toString().toLowerCase()
             .replace(/\s+/g, '-')           // Replace spaces with -
             .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
             .replace(/\-\-+/g, '-')         // Replace multiple - with single -
             .replace(/^-+/, '')             // Trim - from start of text
             .replace(/-+$/, '');            // Trim - from end of text
}

// money format handler
if (!Shopify.formatMoney) {
  Shopify.money_format = "${{amount}}";
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

/*
 * Global Utility Functions
 * Consolidated from multiple files to reduce duplication
 */

/**
 * Escape HTML special characters to prevent XSS
 * @param {string} text - Text to escape
 * @returns {string} Escaped HTML string
 */
function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

/**
 * Parse HTML string into a Document
 * @param {string} html - HTML string to parse
 * @returns {Document} Parsed document
 */
function parseHTML(html) {
  return new DOMParser().parseFromString(html, 'text/html');
}

/**
 * Lock body scroll (for modals, drawers, etc.)
 */
function lockBodyScroll() {
  const nextCount = (window.__intusBodyScrollLockCount || 0) + 1;
  window.__intusBodyScrollLockCount = nextCount;
  document.body.classList.add('overflow-hidden');
}

/**
 * Unlock body scroll
 */
function unlockBodyScroll() {
  const currentCount = window.__intusBodyScrollLockCount || 0;
  const nextCount = Math.max(0, currentCount - 1);
  window.__intusBodyScrollLockCount = nextCount;
  if (nextCount === 0) {
    document.body.classList.remove('overflow-hidden');
  }
}

/**
 * True when the collection/search filter drawer is open on mobile (not desktop inline column).
 * Matches component-facets.css: drawer at max-width 767px, inline column at min-width 768px.
 */
function isMobileCollectionFilterDrawerOpen() {
  if (!window.matchMedia('(max-width: 767px)').matches) return false;
  const filterDrawer = document.getElementById('main-collection-filters');
  return filterDrawer?.getAttribute('aria-expanded') === 'true';
}

/**
 * Reconcile stale body scroll locks after tab focus/visibility changes.
 * Only clears lock state when no known lock-owning UI is visibly active.
 */
function hasActiveScrollLockUI() {
  const lockSelectors = [
    '#overlay.active',
    '#overlay.overlay-fading',
    '#cart-drawer.active',
    'predictive-search[data-search-state="open"]',
    'size-chart-drawer.active',
    'info-drawer.active',
    '#product-gallery-modal.active',
    'product-quick-view-modal.is-open',
    '#currency-drawer.active'
  ];

  if (lockSelectors.some((selector) => document.querySelector(selector))) return true;
  return isMobileCollectionFilterDrawerOpen();
}

function reconcileBodyScrollState() {
  if (document.visibilityState === 'hidden') return;

  const lockCount = window.__intusBodyScrollLockCount || 0;
  const hasHiddenClass = document.body.classList.contains('overflow-hidden');
  const hasInlineHiddenOverflow = document.body.style.overflow === 'hidden';

  if (lockCount === 0 && !hasHiddenClass && !hasInlineHiddenOverflow) return;
  if (hasActiveScrollLockUI()) return;

  window.__intusBodyScrollLockCount = 0;
  document.body.classList.remove('overflow-hidden');

  if (hasInlineHiddenOverflow) {
    document.body.style.overflow = '';
  }
}

(function initBodyScrollReconcileHandlers() {
  let reconcileTimer = null;

  function scheduleReconcile() {
    if (reconcileTimer) clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(() => {
      reconcileBodyScrollState();
      reconcileTimer = null;
    }, 80);
  }

  window.addEventListener('focus', scheduleReconcile);
  window.addEventListener('pageshow', scheduleReconcile);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      scheduleReconcile();
    }
  });
})();

/**
 * Keep aria-expanded updates consistent across toggles.
 * @param {HTMLElement|null} element
 * @param {boolean} expanded
 */
function setAriaExpanded(element, expanded) {
  if (!element || !element.setAttribute) return;
  element.setAttribute('aria-expanded', expanded ? 'true' : 'false');
}

/**
 * Shift the mobile sticky ATC above the Shopify consent banner while it is
 * visible. Smile launcher overlap is handled via z-index in base.css.
 */
(function initShopifyConsentBannerOffset() {
  var BANNER_SEL = '#shopify-pc__banner';
  var banner = null;
  var height = 0;
  var rafId = 0;

  function apply() {
    rafId = 0;
    var sticky = document.querySelector('[data-sticky-atc-mobile]');
    if (!sticky) return;
    var offset = window.innerWidth <= 767 ? height : 0;
    sticky.style.setProperty('--sticky-atc-offset', offset + 'px');
  }

  function schedule() {
    if (rafId) return;
    rafId = requestAnimationFrame(apply);
  }

  function measure() {
    var next = 0;
    if (banner && banner.isConnected) {
      var cs = getComputedStyle(banner);
      if (cs.display !== 'none' && cs.visibility !== 'hidden') {
        var r = banner.getBoundingClientRect();
        if (r.height > 0 && r.bottom > 0) next = Math.ceil(r.height);
      }
    }
    if (next !== height) {
      height = next;
      schedule();
    }
  }

  var resizeObserver = window.ResizeObserver ? new ResizeObserver(measure) : null;
  var bannerAttrObserver = new MutationObserver(measure);

  function attachBanner(el) {
    if (banner === el) return;
    banner = el;
    if (resizeObserver) resizeObserver.observe(el);
    bannerAttrObserver.observe(el, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    measure();
  }

  var scanObserver = null;
  function scan() {
    var b = document.querySelector(BANNER_SEL);
    if (b && b !== banner) {
      attachBanner(b);
      if (scanObserver) {
        scanObserver.disconnect();
        scanObserver = null;
      }
    }
  }

  scanObserver = new MutationObserver(scan);
  scanObserver.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('resize', measure, { passive: true });
  window.addEventListener('orientationchange', measure, { passive: true });
  document.addEventListener('visitorConsentCollected', measure);

  scan();
})();